import { Component, Input } from "@angular/core";
import { IZoneWithProbes } from "@temperature/_models/temperature/ITemperatureZone";
import { ZoneService } from "@temperature/_services/zone.service";
import './zone-setpoint.component.scss';

@Component({
    selector: 'zone-setpoint',
    template: require('./zone-setpoint.component.html')
})
export class ZoneSetPointComponent {
    @Input() zones: IZoneWithProbes[];
    @Input() zonePosition: number;

    //--
    zone: IZoneWithProbes;
    temperature: number;

    constructor(private readonly zoneService: ZoneService) { }

    ngOnInit(): void {
        this.render();
    }

    ngOnChanges(): void {
        this.render();
    }

    // ---

    private render(): void {
        if (typeof this.zones === "string") {
            return;
        }

        this.zone = this.zoneService.getZoneAtPosition(this.zones, this.zonePosition);
        this.temperature = this.zone?.setpointReading;
    }
}
